import { render, staticRenderFns } from "./context_menu_demo.vue?vue&type=template&id=67ffce19&scoped=true&"
import script from "./context_menu_demo.vue?vue&type=script&lang=ts&"
export * from "./context_menu_demo.vue?vue&type=script&lang=ts&"
import style0 from "./context_menu_demo.vue?vue&type=style&index=0&id=67ffce19&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ffce19",
  null
  
)

export default component.exports